module.exports = __webpack_public_path__ + "static/media/cp2in.2184ecf4.png";